import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  Byte: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AccountMetaDto = {
  __typename?: 'AccountMetaDto';
  isSigner: Scalars['Boolean']['output'];
  isWritable: Scalars['Boolean']['output'];
  pubkey: Scalars['String']['output'];
};

export type CollectionItemDto = {
  __typename?: 'CollectionItemDto';
  id: Scalars['ID']['output'];
  mint: Scalars['String']['output'];
  organisationAddres: Scalars['String']['output'];
  repMultiplier: Scalars['Int']['output'];
};

export type CollectionNftRecordDto = {
  __typename?: 'CollectionNftRecordDto';
  address: Scalars['String']['output'];
  collectionMint: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nftCount: Scalars['Int']['output'];
  organisationAddress: Scalars['String']['output'];
};

export type CommentDto = {
  __typename?: 'CommentDto';
  children: Array<CommentDto>;
  childrenCount: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  downvotes: Scalars['Int']['output'];
  edited_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  parent?: Maybe<CommentDto>;
  parentId: Scalars['String']['output'];
  proposal?: Maybe<ProposalDto>;
  proposalAddress: Scalars['String']['output'];
  upvotes: Scalars['Int']['output'];
  user: UserDto;
  userIdentityAddress: Scalars['String']['output'];
  votesTotal: Scalars['Int']['output'];
};

export type ContributionRecordDto = {
  __typename?: 'ContributionRecordDto';
  address: Scalars['String']['output'];
  downVoteCount: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  isClaimed: Scalars['Boolean']['output'];
  organisation?: Maybe<OrganisationDto>;
  organisationAddress: Scalars['String']['output'];
  proposalAddress: Scalars['String']['output'];
  upVoteCount: Scalars['BigInt']['output'];
  user?: Maybe<ProfileDto>;
};

export type ContributionReputationDto = {
  __typename?: 'ContributionReputationDto';
  id: Scalars['ID']['output'];
  proposalVotes: Scalars['Int']['output'];
  proposalVotesInAlignment: Scalars['Int']['output'];
  proposalsCreatedFailed: Scalars['Int']['output'];
  proposalsCreatedSuccess: Scalars['Int']['output'];
  reputationManagerAddress: Scalars['String']['output'];
  servicedProposalsFailed: Scalars['Int']['output'];
  servicedProposalsSuccess: Scalars['Int']['output'];
};

export type CouncilManagerDto = {
  __typename?: 'CouncilManagerDto';
  address: Scalars['String']['output'];
  authority: Scalars['String']['output'];
  councilMembers: Array<CouncilMemberDto>;
  council_count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type CouncilMemberDto = {
  __typename?: 'CouncilMemberDto';
  councilManagerAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  user: ProfileDto;
};

export type CouncilVoteRecordDto = {
  __typename?: 'CouncilVoteRecordDto';
  address: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organisation?: Maybe<OrganisationDto>;
  organisationAddress: Scalars['String']['output'];
  proposalAddress: Scalars['String']['output'];
  review_score?: Maybe<Scalars['Int']['output']>;
  user: ProfileDto;
  vote: Scalars['String']['output'];
};

export type FollowerDto = {
  __typename?: 'FollowerDto';
  createdAt: Scalars['String']['output'];
  user: UserDto;
};

export type IdentityDto = {
  __typename?: 'IdentityDto';
  bump: Scalars['Int']['output'];
  did?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  identityAddress: Scalars['String']['output'];
  isInRecovery: Scalars['Boolean']['output'];
  isTokenized: Scalars['Boolean']['output'];
  node?: Maybe<NodeDto>;
  owner: Scalars['String']['output'];
  recoveryCount: Scalars['Int']['output'];
  recoveryKey?: Maybe<Scalars['String']['output']>;
  totalEditionsPrinted: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type MeRankingVotesDto = {
  __typename?: 'MeRankingVotesDto';
  contributionRecord?: Maybe<ContributionRecordDto>;
  hasRanked: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createComment: CommentDto;
  voteOnComment: CommentDto;
};


export type MutationCreateCommentArgs = {
  comment: Scalars['String']['input'];
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  proposalAddress: Scalars['String']['input'];
};


export type MutationVoteOnCommentArgs = {
  id: Scalars['String']['input'];
  voteType: Scalars['String']['input'];
};

export type NodeDto = {
  __typename?: 'NodeDto';
  accountAddress: Scalars['String']['output'];
  address: Scalars['String']['output'];
  bump: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  edgesFrom: Array<FollowerDto>;
  edgesTo: Array<FollowerDto>;
  followerCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  likeCount: Scalars['Int']['output'];
  nodeType: NodeType;
  programId: Scalars['String']['output'];
};


export type NodeDtoEdgesFromArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};


export type NodeDtoEdgesToArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export enum NodeType {
  Post = 'Post',
  User = 'User'
}

export type OrganisationConfigDto = {
  __typename?: 'OrganisationConfigDto';
  id: Scalars['ID']['output'];
  nftRequireForActions: Scalars['Boolean']['output'];
  proposalCreatedReward: Scalars['BigInt']['output'];
  proposalMinReputationGate?: Maybe<Scalars['BigInt']['output']>;
  proposalServicedReward: Scalars['BigInt']['output'];
  rankingPeriod: Scalars['BigInt']['output'];
  votingRepReward: Scalars['BigInt']['output'];
};

export type OrganisationDto = {
  __typename?: 'OrganisationDto';
  address: Scalars['String']['output'];
  collectionItems?: Maybe<Array<CollectionItemDto>>;
  config?: Maybe<OrganisationConfigDto>;
  councilManager?: Maybe<CouncilManagerDto>;
  currentVotingProposals: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  profile?: Maybe<ProfileDto>;
  proposals: Array<ProposalDto>;
  wallets: Array<WalletDto>;
};


export type OrganisationDtoProposalsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type OwnerRecordDto = {
  __typename?: 'OwnerRecordDto';
  account: Scalars['String']['output'];
  address: Scalars['String']['output'];
  bump: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  identity: IdentityDto;
  identityId: Scalars['String']['output'];
  isDelegate: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  keyAccountOwner: Scalars['String']['output'];
  mintAddress?: Maybe<Scalars['String']['output']>;
  reserved: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  user?: Maybe<UserDto>;
};

export type PageInfoDto = {
  __typename?: 'PageInfoDto';
  count: Scalars['Float']['output'];
  cursor?: Maybe<Scalars['String']['output']>;
  take: Scalars['Float']['output'];
};

export type PaginatedProposals = {
  __typename?: 'PaginatedProposals';
  pageInfo: PageInfoDto;
  proposals: Array<ProposalDto>;
};

export type ProfileDto = {
  __typename?: 'ProfileDto';
  address: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  pfp?: Maybe<Scalars['String']['output']>;
  userIdentityAddress: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type ProposalDto = {
  __typename?: 'ProposalDto';
  address: Scalars['String']['output'];
  approvedAt?: Maybe<Scalars['String']['output']>;
  authorityConfigAddress: Scalars['String']['output'];
  commentCount: Scalars['Int']['output'];
  councilReviewCount: Scalars['Int']['output'];
  councilReviewRating?: Maybe<Scalars['Int']['output']>;
  councilVotes: Array<CouncilVoteRecordDto>;
  deniedAt?: Maybe<Scalars['String']['output']>;
  downvotes: Scalars['BigInt']['output'];
  draftAt?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['String']['output']>;
  executingTransactionIndex?: Maybe<Scalars['Int']['output']>;
  hasRankVotes: MeRankingVotesDto;
  id: Scalars['ID']['output'];
  organisationAddress: Scalars['String']['output'];
  proposalTransactions: Array<ProposalTransactionDto>;
  proposer?: Maybe<UserDto>;
  proposerIdentifier: Scalars['String']['output'];
  proposerIdentityAddress: Scalars['String']['output'];
  rankingAt?: Maybe<Scalars['String']['output']>;
  rankingPeriod: Scalars['BigInt']['output'];
  rankingTotal: Scalars['BigInt']['output'];
  rankingVotes: Array<ContributionRecordDto>;
  serviceProofs: Array<Scalars['String']['output']>;
  servicer?: Maybe<UserDto>;
  servicerAcceptedAt?: Maybe<Scalars['String']['output']>;
  servicerDeclinedAt?: Maybe<Scalars['String']['output']>;
  servicerIdentifier?: Maybe<Scalars['String']['output']>;
  servicerIdentityAddress?: Maybe<Scalars['String']['output']>;
  shadowDrive: Scalars['String']['output'];
  state: ProposalState;
  totalCouncilAbstainVotes: Scalars['Int']['output'];
  totalCouncilNoVotes: Scalars['Int']['output'];
  totalCouncilYesVotes: Scalars['Int']['output'];
  transactionCount: Scalars['Int']['output'];
  upvotes: Scalars['BigInt']['output'];
  votingAt?: Maybe<Scalars['String']['output']>;
};


export type ProposalDtoHasRankVotesArgs = {
  userIdentifier: Scalars['String']['input'];
};


export type ProposalDtoRankingVotesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type ProposalInstructionDto = {
  __typename?: 'ProposalInstructionDto';
  accounts: Array<AccountMetaDto>;
  address: Scalars['String']['output'];
  data: Scalars['JSONObject']['output'];
  id: Scalars['ID']['output'];
  instruction_index: Scalars['Int']['output'];
  is_executed: Scalars['Boolean']['output'];
  program_id: Scalars['String']['output'];
  transactionAddress: Scalars['String']['output'];
};

export enum ProposalState {
  Canceled = 'Canceled',
  Complete = 'Complete',
  Denied = 'Denied',
  Draft = 'Draft',
  Executing = 'Executing',
  Ranking = 'Ranking',
  ReadyToExecute = 'ReadyToExecute',
  RequestingServicer = 'RequestingServicer',
  ReviewFailed = 'ReviewFailed',
  Reviewed = 'Reviewed',
  Reviewing = 'Reviewing',
  Servicing = 'Servicing',
  Voting = 'Voting'
}

export type ProposalTransactionDto = {
  __typename?: 'ProposalTransactionDto';
  address: Scalars['String']['output'];
  executedById?: Maybe<Scalars['String']['output']>;
  executed_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  proposalAddress: Scalars['String']['output'];
  proposalInstuctions: Array<ProposalInstructionDto>;
  state: TransactionState;
};

export type Query = {
  __typename?: 'Query';
  comments: Array<CommentDto>;
  node: NodeDto;
  organisation: OrganisationDto;
  organisations: Array<OrganisationDto>;
  proposal: ProposalDto;
  proposals: PaginatedProposals;
  reputation: ReputationDto;
  user: UserDto;
};


export type QueryCommentsArgs = {
  address: Scalars['String']['input'];
  commentParentId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNodeArgs = {
  address: Scalars['String']['input'];
};


export type QueryOrganisationArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProposalArgs = {
  address: Scalars['String']['input'];
};


export type QueryProposalsArgs = {
  councilVoter?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orgAddress?: InputMaybe<Scalars['String']['input']>;
  proposerAddress?: InputMaybe<Scalars['String']['input']>;
  servicerAddress?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryReputationArgs = {
  organisationAddress: Scalars['String']['input'];
  userIdentityAddress: Scalars['String']['input'];
};


export type QueryUserArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ReputationDto = {
  __typename?: 'ReputationDto';
  address: Scalars['String']['output'];
  collectionNftRecords: Array<CollectionNftRecordDto>;
  contributionReputation: ContributionReputationDto;
  id: Scalars['ID']['output'];
  organisation: OrganisationDto;
  organisationAddress: Scalars['String']['output'];
  totalReputation: Scalars['BigInt']['output'];
  user: UserDto;
  userIdentifier: Scalars['String']['output'];
  userIdentityAddress: Scalars['String']['output'];
};

export enum TransactionState {
  Executing = 'Executing',
  Failed = 'Failed',
  Success = 'Success',
  Waiting = 'Waiting'
}

export type UserDto = {
  __typename?: 'UserDto';
  address: Scalars['String']['output'];
  customData?: Maybe<Scalars['JSONObject']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identity?: Maybe<IdentityDto>;
  node: NodeDto;
  ownerRecords: Array<OwnerRecordDto>;
  pfp?: Maybe<Scalars['String']['output']>;
  userIdentityAddress?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type WalletDto = {
  __typename?: 'WalletDto';
  address: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organisation: Scalars['String']['output'];
  seed: Scalars['Byte']['output'];
  threshold: Scalars['Int']['output'];
  totalProposals: Scalars['BigInt']['output'];
  votingProposalCount: Scalars['Int']['output'];
  walletAddress: Scalars['String']['output'];
};

export type GetOrganisationQueryVariables = Exact<{
  address: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Float']['input']>;
  proposalCursor?: InputMaybe<Scalars['String']['input']>;
  proposalState?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganisationQuery = { __typename?: 'Query', organisation: { __typename?: 'OrganisationDto', id: string, address: string, identifier: string, councilManager?: { __typename?: 'CouncilManagerDto', address: string, authority: string, council_count: number, councilMembers: Array<{ __typename?: 'CouncilMemberDto', councilManagerAddress: string, user: { __typename?: 'ProfileDto', username: string, displayName: string, pfp?: string | null, userIdentityAddress: string } }> } | null, proposals: Array<{ __typename?: 'ProposalDto', address: string, proposerIdentifier: string, organisationAddress: string, state: ProposalState, totalCouncilYesVotes: number, totalCouncilNoVotes: number, councilReviewCount: number, councilReviewRating?: number | null, draftAt?: string | null, upvotes: any, downvotes: any, rankingTotal: any, proposer?: { __typename?: 'UserDto', displayName: string, username: string } | null, servicer?: { __typename?: 'UserDto', displayName: string, username: string } | null, councilVotes: Array<{ __typename?: 'CouncilVoteRecordDto', vote: string, id: string }>, rankingVotes: Array<{ __typename?: 'ContributionRecordDto', upVoteCount: any, downVoteCount: any, user?: { __typename?: 'ProfileDto', displayName: string } | null }> }>, wallets: Array<{ __typename?: 'WalletDto', walletAddress: string, address: string, votingProposalCount: number, name: string, threshold: number, totalProposals: any }>, profile?: { __typename?: 'ProfileDto', pfp?: string | null, userIdentityAddress: string, username: string, displayName: string } | null, config?: { __typename?: 'OrganisationConfigDto', votingRepReward: any, proposalServicedReward: any, proposalCreatedReward: any, nftRequireForActions: boolean, rankingPeriod: any, proposalMinReputationGate?: any | null } | null, collectionItems?: Array<{ __typename?: 'CollectionItemDto', mint: string, repMultiplier: number }> | null } };

export type GetOrganisationsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Float']['input']>;
  proposalCursor?: InputMaybe<Scalars['String']['input']>;
  proposalState?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganisationsQuery = { __typename?: 'Query', organisations: Array<{ __typename?: 'OrganisationDto', id: string, address: string, identifier: string, councilManager?: { __typename?: 'CouncilManagerDto', address: string, council_count: number, councilMembers: Array<{ __typename?: 'CouncilMemberDto', councilManagerAddress: string, user: { __typename?: 'ProfileDto', username: string, displayName: string, pfp?: string | null, userIdentityAddress: string } }> } | null, proposals: Array<{ __typename?: 'ProposalDto', address: string, proposerIdentifier: string, organisationAddress: string, state: ProposalState, totalCouncilYesVotes: number, totalCouncilNoVotes: number, councilReviewCount: number, councilReviewRating?: number | null, draftAt?: string | null, upvotes: any, downvotes: any, rankingTotal: any, proposer?: { __typename?: 'UserDto', displayName: string } | null, servicer?: { __typename?: 'UserDto', displayName: string } | null, councilVotes: Array<{ __typename?: 'CouncilVoteRecordDto', vote: string, id: string }>, rankingVotes: Array<{ __typename?: 'ContributionRecordDto', upVoteCount: any, downVoteCount: any, user?: { __typename?: 'ProfileDto', displayName: string } | null }> }>, profile?: { __typename?: 'ProfileDto', pfp?: string | null, userIdentityAddress: string, username: string, displayName: string } | null, wallets: Array<{ __typename?: 'WalletDto', walletAddress: string, address: string, votingProposalCount: number, name: string, threshold: number, totalProposals: any }>, config?: { __typename?: 'OrganisationConfigDto', votingRepReward: any, proposalServicedReward: any, proposalCreatedReward: any, nftRequireForActions: boolean, rankingPeriod: any, proposalMinReputationGate?: any | null } | null, collectionItems?: Array<{ __typename?: 'CollectionItemDto', mint: string, repMultiplier: number }> | null }> };

export type GetProposalQueryVariables = Exact<{
  address: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Float']['input']>;
  userIdentifier: Scalars['String']['input'];
}>;


export type GetProposalQuery = { __typename?: 'Query', proposal: { __typename?: 'ProposalDto', address: string, proposerIdentifier: string, serviceProofs: Array<string>, authorityConfigAddress: string, organisationAddress: string, state: ProposalState, shadowDrive: string, totalCouncilYesVotes: number, totalCouncilNoVotes: number, totalCouncilAbstainVotes: number, councilReviewCount: number, councilReviewRating?: number | null, approvedAt?: string | null, draftAt?: string | null, votingAt?: string | null, deniedAt?: string | null, rankingAt?: string | null, executedAt?: string | null, upvotes: any, downvotes: any, rankingPeriod: any, rankingTotal: any, commentCount: number, proposer?: { __typename?: 'UserDto', userIdentityAddress?: string | null, username: string, displayName: string, pfp?: string | null, identity?: { __typename?: 'IdentityDto', identifier: string } | null } | null, servicer?: { __typename?: 'UserDto', userIdentityAddress?: string | null, username: string, displayName: string, pfp?: string | null, identity?: { __typename?: 'IdentityDto', identifier: string } | null } | null, proposalTransactions: Array<{ __typename?: 'ProposalTransactionDto', state: TransactionState, executed_at?: string | null, executedById?: string | null, proposalInstuctions: Array<{ __typename?: 'ProposalInstructionDto', instruction_index: number, transactionAddress: string, program_id: string, data: any, accounts: Array<{ __typename?: 'AccountMetaDto', pubkey: string, isSigner: boolean, isWritable: boolean }> }> }>, hasRankVotes: { __typename?: 'MeRankingVotesDto', hasRanked: boolean, contributionRecord?: { __typename?: 'ContributionRecordDto', address: string, isClaimed: boolean, upVoteCount: any, downVoteCount: any } | null }, councilVotes: Array<{ __typename?: 'CouncilVoteRecordDto', vote: string, address: string, review_score?: number | null, id: string, user: { __typename?: 'ProfileDto', username: string, displayName: string, userIdentityAddress: string, pfp?: string | null } }>, rankingVotes: Array<{ __typename?: 'ContributionRecordDto', upVoteCount: any, downVoteCount: any, user?: { __typename?: 'ProfileDto', displayName: string } | null }> } };

export type GetProposalsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  proposerAddress?: InputMaybe<Scalars['String']['input']>;
  orgAddress: Scalars['String']['input'];
  userIdentifier: Scalars['String']['input'];
  councilVoter?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProposalsQuery = { __typename?: 'Query', proposals: { __typename?: 'PaginatedProposals', pageInfo: { __typename?: 'PageInfoDto', count: number, take: number, cursor?: string | null }, proposals: Array<{ __typename?: 'ProposalDto', address: string, proposerIdentifier: string, organisationAddress: string, state: ProposalState, shadowDrive: string, totalCouncilYesVotes: number, totalCouncilNoVotes: number, councilReviewCount: number, councilReviewRating?: number | null, approvedAt?: string | null, draftAt?: string | null, votingAt?: string | null, deniedAt?: string | null, rankingAt?: string | null, executedAt?: string | null, upvotes: any, downvotes: any, rankingPeriod: any, rankingTotal: any, proposer?: { __typename?: 'UserDto', userIdentityAddress?: string | null, username: string, displayName: string, pfp?: string | null, identity?: { __typename?: 'IdentityDto', identifier: string } | null } | null, servicer?: { __typename?: 'UserDto', userIdentityAddress?: string | null, username: string, displayName: string, pfp?: string | null, identity?: { __typename?: 'IdentityDto', identifier: string } | null } | null, proposalTransactions: Array<{ __typename?: 'ProposalTransactionDto', state: TransactionState, executed_at?: string | null, executedById?: string | null, proposalInstuctions: Array<{ __typename?: 'ProposalInstructionDto', instruction_index: number, transactionAddress: string, program_id: string, data: any, accounts: Array<{ __typename?: 'AccountMetaDto', pubkey: string, isSigner: boolean, isWritable: boolean }> }> }>, hasRankVotes: { __typename?: 'MeRankingVotesDto', hasRanked: boolean, contributionRecord?: { __typename?: 'ContributionRecordDto', address: string, isClaimed: boolean, upVoteCount: any, downVoteCount: any } | null }, councilVotes: Array<{ __typename?: 'CouncilVoteRecordDto', vote: string, id: string }>, rankingVotes: Array<{ __typename?: 'ContributionRecordDto', upVoteCount: any, downVoteCount: any, user?: { __typename?: 'ProfileDto', displayName: string } | null }> }> } };

export type GetProposalCountQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  proposerAddress?: InputMaybe<Scalars['String']['input']>;
  orgAddress: Scalars['String']['input'];
  councilVoter?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProposalCountQuery = { __typename?: 'Query', proposals: { __typename?: 'PaginatedProposals', pageInfo: { __typename?: 'PageInfoDto', count: number, take: number, cursor?: string | null } } };

export type GetCommentsQueryVariables = Exact<{
  proposalAddress: Scalars['String']['input'];
  commentParentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCommentsQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'CommentDto', id: string, comment: string, upvotes: number, votesTotal: number, downvotes: number, created_at: string, proposalAddress: string, childrenCount: number, user: { __typename?: 'UserDto', userIdentityAddress?: string | null, pfp?: string | null, username: string, displayName: string }, parent?: { __typename?: 'CommentDto', id: string } | null, children: Array<{ __typename?: 'CommentDto', id: string, comment: string, upvotes: number, votesTotal: number, downvotes: number, created_at: string, proposalAddress: string, childrenCount: number, user: { __typename?: 'UserDto', userIdentityAddress?: string | null, pfp?: string | null, username: string, displayName: string }, parent?: { __typename?: 'CommentDto', id: string } | null, children: Array<{ __typename?: 'CommentDto', id: string, comment: string, upvotes: number, votesTotal: number, downvotes: number, created_at: string, proposalAddress: string, childrenCount: number, user: { __typename?: 'UserDto', userIdentityAddress?: string | null, pfp?: string | null, username: string, displayName: string }, parent?: { __typename?: 'CommentDto', id: string } | null }> }> }> };

export type VoteOnCommentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  voteType: Scalars['String']['input'];
}>;


export type VoteOnCommentMutation = { __typename?: 'Mutation', voteOnComment: { __typename?: 'CommentDto', id: string, votesTotal: number } };

export type CreateCommentMutationVariables = Exact<{
  proposalAddress: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CommentDto', id: string, votesTotal: number } };

export type GetUserQueryVariables = Exact<{
  address?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserQuery = { __typename?: 'Query', user: { __typename?: 'UserDto', username: string, id: string, displayName: string, pfp?: string | null, userIdentityAddress?: string | null, ownerRecords: Array<{ __typename?: 'OwnerRecordDto', account: string, isVerified: boolean, id: string }>, identity?: { __typename?: 'IdentityDto', owner: string, identifier: string, identityAddress: string, recoveryKey?: string | null, recoveryCount: number, totalEditionsPrinted: number, updatedAt: string } | null, node: { __typename?: 'NodeDto', accountAddress: string, followerCount: number, id: string, edgesFrom: Array<{ __typename?: 'FollowerDto', createdAt: string, user: { __typename?: 'UserDto', username: string, displayName: string, pfp?: string | null, identity?: { __typename?: 'IdentityDto', identifier: string } | null, node: { __typename?: 'NodeDto', followerCount: number, id: string } } }>, edgesTo: Array<{ __typename?: 'FollowerDto', createdAt: string, user: { __typename?: 'UserDto', username: string, displayName: string, identity?: { __typename?: 'IdentityDto', identifier: string } | null, node: { __typename?: 'NodeDto', followerCount: number, id: string } } }> } } };

export type GetReputationQueryVariables = Exact<{
  userIdentityAddress: Scalars['String']['input'];
  organisationAddress: Scalars['String']['input'];
}>;


export type GetReputationQuery = { __typename?: 'Query', reputation: { __typename?: 'ReputationDto', organisationAddress: string, totalReputation: any, contributionReputation: { __typename?: 'ContributionReputationDto', id: string, proposalVotes: number, proposalVotesInAlignment: number, proposalsCreatedFailed: number, proposalsCreatedSuccess: number, servicedProposalsFailed: number, servicedProposalsSuccess: number }, collectionNftRecords: Array<{ __typename?: 'CollectionNftRecordDto', id: string, address: string, nftCount: number, organisationAddress: string, collectionMint: string }> } };


export const GetOrganisationDocument = gql`
    query GetOrganisation($address: String!, $take: Float, $proposalCursor: String, $proposalState: String) {
  organisation(address: $address) {
    id
    address
    identifier
    councilManager {
      address
      authority
      council_count
      councilMembers {
        councilManagerAddress
        user {
          username
          displayName
          pfp
          userIdentityAddress
        }
      }
    }
    proposals(take: $take, cursor: $proposalCursor, state: $proposalState) {
      address
      proposerIdentifier
      organisationAddress
      proposer {
        displayName
        username
      }
      servicer {
        displayName
        username
      }
      state
      totalCouncilYesVotes
      totalCouncilNoVotes
      councilReviewCount
      councilReviewRating
      draftAt
      upvotes
      downvotes
      councilVotes {
        vote
        id
      }
      rankingTotal
      rankingVotes(take: $take) {
        user {
          displayName
        }
        upVoteCount
        downVoteCount
      }
    }
    wallets {
      walletAddress
      address
      votingProposalCount
      name
      threshold
      totalProposals
    }
    profile {
      pfp
      userIdentityAddress
      username
      displayName
    }
    config {
      votingRepReward
      proposalServicedReward
      proposalCreatedReward
      nftRequireForActions
      rankingPeriod
      proposalMinReputationGate
    }
    collectionItems {
      mint
      repMultiplier
    }
  }
}
    `;

/**
 * __useGetOrganisationQuery__
 *
 * To run a query within a React component, call `useGetOrganisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationQuery({
 *   variables: {
 *      address: // value for 'address'
 *      take: // value for 'take'
 *      proposalCursor: // value for 'proposalCursor'
 *      proposalState: // value for 'proposalState'
 *   },
 * });
 */
export function useGetOrganisationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationQuery, GetOrganisationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationQuery, GetOrganisationQueryVariables>(GetOrganisationDocument, options);
      }
export function useGetOrganisationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationQuery, GetOrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationQuery, GetOrganisationQueryVariables>(GetOrganisationDocument, options);
        }
export type GetOrganisationQueryHookResult = ReturnType<typeof useGetOrganisationQuery>;
export type GetOrganisationLazyQueryHookResult = ReturnType<typeof useGetOrganisationLazyQuery>;
export type GetOrganisationQueryResult = Apollo.QueryResult<GetOrganisationQuery, GetOrganisationQueryVariables>;
export const GetOrganisationsDocument = gql`
    query GetOrganisations($take: Float, $proposalCursor: String, $proposalState: String) {
  organisations {
    id
    address
    identifier
    councilManager {
      address
      council_count
      councilMembers {
        councilManagerAddress
        user {
          username
          displayName
          pfp
          userIdentityAddress
        }
      }
    }
    proposals(take: $take, cursor: $proposalCursor, state: $proposalState) {
      address
      proposerIdentifier
      organisationAddress
      proposer {
        displayName
      }
      servicer {
        displayName
      }
      state
      totalCouncilYesVotes
      totalCouncilNoVotes
      councilReviewCount
      councilReviewRating
      draftAt
      upvotes
      downvotes
      councilVotes {
        vote
        id
      }
      rankingTotal
      rankingVotes(take: $take) {
        user {
          displayName
        }
        upVoteCount
        downVoteCount
      }
    }
    profile {
      pfp
      userIdentityAddress
      username
      displayName
    }
    wallets {
      walletAddress
      address
      votingProposalCount
      name
      threshold
      totalProposals
    }
    config {
      votingRepReward
      proposalServicedReward
      proposalCreatedReward
      nftRequireForActions
      rankingPeriod
      proposalMinReputationGate
    }
    collectionItems {
      mint
      repMultiplier
    }
  }
}
    `;

/**
 * __useGetOrganisationsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      proposalCursor: // value for 'proposalCursor'
 *      proposalState: // value for 'proposalState'
 *   },
 * });
 */
export function useGetOrganisationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganisationsQuery, GetOrganisationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationsQuery, GetOrganisationsQueryVariables>(GetOrganisationsDocument, options);
      }
export function useGetOrganisationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationsQuery, GetOrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationsQuery, GetOrganisationsQueryVariables>(GetOrganisationsDocument, options);
        }
export type GetOrganisationsQueryHookResult = ReturnType<typeof useGetOrganisationsQuery>;
export type GetOrganisationsLazyQueryHookResult = ReturnType<typeof useGetOrganisationsLazyQuery>;
export type GetOrganisationsQueryResult = Apollo.QueryResult<GetOrganisationsQuery, GetOrganisationsQueryVariables>;
export const GetProposalDocument = gql`
    query GetProposal($address: String!, $take: Float, $userIdentifier: String!) {
  proposal(address: $address) {
    address
    proposerIdentifier
    serviceProofs
    authorityConfigAddress
    organisationAddress
    proposer {
      userIdentityAddress
      username
      displayName
      username
      pfp
      identity {
        identifier
      }
    }
    servicer {
      userIdentityAddress
      username
      displayName
      username
      pfp
      identity {
        identifier
      }
    }
    state
    proposalTransactions {
      state
      executed_at
      executedById
      proposalInstuctions {
        instruction_index
        transactionAddress
        program_id
        data
        accounts {
          pubkey
          isSigner
          isWritable
        }
      }
    }
    hasRankVotes(userIdentifier: $userIdentifier) {
      hasRanked
      contributionRecord {
        address
        isClaimed
        upVoteCount
        downVoteCount
      }
    }
    shadowDrive
    totalCouncilYesVotes
    totalCouncilNoVotes
    totalCouncilAbstainVotes
    councilReviewCount
    councilReviewRating
    approvedAt
    draftAt
    votingAt
    deniedAt
    rankingAt
    executedAt
    upvotes
    downvotes
    rankingPeriod
    councilVotes {
      vote
      address
      review_score
      id
      user {
        username
        displayName
        userIdentityAddress
        pfp
      }
    }
    rankingTotal
    rankingVotes(take: $take) {
      user {
        displayName
      }
      upVoteCount
      downVoteCount
    }
    commentCount
  }
}
    `;

/**
 * __useGetProposalQuery__
 *
 * To run a query within a React component, call `useGetProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalQuery({
 *   variables: {
 *      address: // value for 'address'
 *      take: // value for 'take'
 *      userIdentifier: // value for 'userIdentifier'
 *   },
 * });
 */
export function useGetProposalQuery(baseOptions: Apollo.QueryHookOptions<GetProposalQuery, GetProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalQuery, GetProposalQueryVariables>(GetProposalDocument, options);
      }
export function useGetProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalQuery, GetProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalQuery, GetProposalQueryVariables>(GetProposalDocument, options);
        }
export type GetProposalQueryHookResult = ReturnType<typeof useGetProposalQuery>;
export type GetProposalLazyQueryHookResult = ReturnType<typeof useGetProposalLazyQuery>;
export type GetProposalQueryResult = Apollo.QueryResult<GetProposalQuery, GetProposalQueryVariables>;
export const GetProposalsDocument = gql`
    query GetProposals($take: Float, $filter: [String!], $proposerAddress: String, $orgAddress: String!, $userIdentifier: String!, $councilVoter: String, $cursor: String) {
  proposals(
    take: $take
    filter: $filter
    proposerAddress: $proposerAddress
    orgAddress: $orgAddress
    councilVoter: $councilVoter
    cursor: $cursor
  ) {
    pageInfo {
      count
      take
      cursor
    }
    proposals {
      address
      proposerIdentifier
      organisationAddress
      proposer {
        userIdentityAddress
        username
        displayName
        username
        pfp
        identity {
          identifier
        }
      }
      servicer {
        userIdentityAddress
        username
        displayName
        username
        pfp
        identity {
          identifier
        }
      }
      state
      proposalTransactions {
        state
        executed_at
        executedById
        proposalInstuctions {
          instruction_index
          transactionAddress
          program_id
          data
          accounts {
            pubkey
            isSigner
            isWritable
          }
        }
      }
      hasRankVotes(userIdentifier: $userIdentifier) {
        hasRanked
        contributionRecord {
          address
          isClaimed
          upVoteCount
          downVoteCount
        }
      }
      shadowDrive
      totalCouncilYesVotes
      totalCouncilNoVotes
      councilReviewCount
      councilReviewRating
      approvedAt
      draftAt
      votingAt
      deniedAt
      rankingAt
      executedAt
      upvotes
      downvotes
      rankingPeriod
      councilVotes {
        vote
        id
      }
      rankingTotal
      rankingVotes(take: $take) {
        user {
          displayName
        }
        upVoteCount
        downVoteCount
      }
    }
  }
}
    `;

/**
 * __useGetProposalsQuery__
 *
 * To run a query within a React component, call `useGetProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      filter: // value for 'filter'
 *      proposerAddress: // value for 'proposerAddress'
 *      orgAddress: // value for 'orgAddress'
 *      userIdentifier: // value for 'userIdentifier'
 *      councilVoter: // value for 'councilVoter'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetProposalsQuery(baseOptions: Apollo.QueryHookOptions<GetProposalsQuery, GetProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalsQuery, GetProposalsQueryVariables>(GetProposalsDocument, options);
      }
export function useGetProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalsQuery, GetProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalsQuery, GetProposalsQueryVariables>(GetProposalsDocument, options);
        }
export type GetProposalsQueryHookResult = ReturnType<typeof useGetProposalsQuery>;
export type GetProposalsLazyQueryHookResult = ReturnType<typeof useGetProposalsLazyQuery>;
export type GetProposalsQueryResult = Apollo.QueryResult<GetProposalsQuery, GetProposalsQueryVariables>;
export const GetProposalCountDocument = gql`
    query GetProposalCount($take: Float, $filter: [String!], $proposerAddress: String, $orgAddress: String!, $councilVoter: String, $cursor: String) {
  proposals(
    take: $take
    filter: $filter
    proposerAddress: $proposerAddress
    orgAddress: $orgAddress
    councilVoter: $councilVoter
    cursor: $cursor
  ) {
    pageInfo {
      count
      take
      cursor
    }
  }
}
    `;

/**
 * __useGetProposalCountQuery__
 *
 * To run a query within a React component, call `useGetProposalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalCountQuery({
 *   variables: {
 *      take: // value for 'take'
 *      filter: // value for 'filter'
 *      proposerAddress: // value for 'proposerAddress'
 *      orgAddress: // value for 'orgAddress'
 *      councilVoter: // value for 'councilVoter'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetProposalCountQuery(baseOptions: Apollo.QueryHookOptions<GetProposalCountQuery, GetProposalCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalCountQuery, GetProposalCountQueryVariables>(GetProposalCountDocument, options);
      }
export function useGetProposalCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalCountQuery, GetProposalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalCountQuery, GetProposalCountQueryVariables>(GetProposalCountDocument, options);
        }
export type GetProposalCountQueryHookResult = ReturnType<typeof useGetProposalCountQuery>;
export type GetProposalCountLazyQueryHookResult = ReturnType<typeof useGetProposalCountLazyQuery>;
export type GetProposalCountQueryResult = Apollo.QueryResult<GetProposalCountQuery, GetProposalCountQueryVariables>;
export const GetCommentsDocument = gql`
    query GetComments($proposalAddress: String!, $commentParentId: String) {
  comments(address: $proposalAddress, commentParentId: $commentParentId) {
    id
    comment
    upvotes
    votesTotal
    downvotes
    created_at
    proposalAddress
    user {
      userIdentityAddress
      pfp
      username
      displayName
    }
    parent {
      id
    }
    children {
      id
      comment
      upvotes
      votesTotal
      downvotes
      created_at
      proposalAddress
      user {
        userIdentityAddress
        pfp
        username
        displayName
      }
      parent {
        id
      }
      childrenCount
      children {
        id
        comment
        upvotes
        votesTotal
        downvotes
        created_at
        proposalAddress
        user {
          userIdentityAddress
          pfp
          username
          displayName
        }
        parent {
          id
        }
        childrenCount
      }
    }
    childrenCount
  }
}
    `;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      proposalAddress: // value for 'proposalAddress'
 *      commentParentId: // value for 'commentParentId'
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsQueryResult = Apollo.QueryResult<GetCommentsQuery, GetCommentsQueryVariables>;
export const VoteOnCommentDocument = gql`
    mutation voteOnComment($id: String!, $voteType: String!) {
  voteOnComment(id: $id, voteType: $voteType) {
    id
    votesTotal
  }
}
    `;
export type VoteOnCommentMutationFn = Apollo.MutationFunction<VoteOnCommentMutation, VoteOnCommentMutationVariables>;

/**
 * __useVoteOnCommentMutation__
 *
 * To run a mutation, you first call `useVoteOnCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoteOnCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voteOnCommentMutation, { data, loading, error }] = useVoteOnCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      voteType: // value for 'voteType'
 *   },
 * });
 */
export function useVoteOnCommentMutation(baseOptions?: Apollo.MutationHookOptions<VoteOnCommentMutation, VoteOnCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoteOnCommentMutation, VoteOnCommentMutationVariables>(VoteOnCommentDocument, options);
      }
export type VoteOnCommentMutationHookResult = ReturnType<typeof useVoteOnCommentMutation>;
export type VoteOnCommentMutationResult = Apollo.MutationResult<VoteOnCommentMutation>;
export type VoteOnCommentMutationOptions = Apollo.BaseMutationOptions<VoteOnCommentMutation, VoteOnCommentMutationVariables>;
export const CreateCommentDocument = gql`
    mutation createComment($proposalAddress: String!, $comment: String!, $parentCommentId: String) {
  createComment(
    proposalAddress: $proposalAddress
    comment: $comment
    parentCommentId: $parentCommentId
  ) {
    id
    votesTotal
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      proposalAddress: // value for 'proposalAddress'
 *      comment: // value for 'comment'
 *      parentCommentId: // value for 'parentCommentId'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const GetUserDocument = gql`
    query GetUser($address: String, $identifier: String, $username: String) {
  user(address: $address, identifier: $identifier, username: $username) {
    username
    id
    displayName
    pfp
    userIdentityAddress
    ownerRecords {
      account
      isVerified
      id
    }
    identity {
      owner
      identifier
      identityAddress
      recoveryKey
      recoveryCount
      totalEditionsPrinted
      updatedAt
    }
    node {
      accountAddress
      edgesFrom {
        user {
          username
          displayName
          pfp
          identity {
            identifier
          }
          node {
            followerCount
            id
          }
        }
        createdAt
      }
      followerCount
      id
      edgesTo(take: 10) {
        user {
          username
          displayName
          identity {
            identifier
          }
          node {
            followerCount
            id
          }
        }
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      address: // value for 'address'
 *      identifier: // value for 'identifier'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetReputationDocument = gql`
    query GetReputation($userIdentityAddress: String!, $organisationAddress: String!) {
  reputation(
    userIdentityAddress: $userIdentityAddress
    organisationAddress: $organisationAddress
  ) {
    organisationAddress
    totalReputation
    contributionReputation {
      id
      proposalVotes
      proposalVotesInAlignment
      proposalsCreatedFailed
      proposalsCreatedSuccess
      servicedProposalsFailed
      servicedProposalsSuccess
    }
    collectionNftRecords {
      id
      address
      nftCount
      organisationAddress
      collectionMint
    }
  }
}
    `;

/**
 * __useGetReputationQuery__
 *
 * To run a query within a React component, call `useGetReputationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReputationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReputationQuery({
 *   variables: {
 *      userIdentityAddress: // value for 'userIdentityAddress'
 *      organisationAddress: // value for 'organisationAddress'
 *   },
 * });
 */
export function useGetReputationQuery(baseOptions: Apollo.QueryHookOptions<GetReputationQuery, GetReputationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReputationQuery, GetReputationQueryVariables>(GetReputationDocument, options);
      }
export function useGetReputationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReputationQuery, GetReputationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReputationQuery, GetReputationQueryVariables>(GetReputationDocument, options);
        }
export type GetReputationQueryHookResult = ReturnType<typeof useGetReputationQuery>;
export type GetReputationLazyQueryHookResult = ReturnType<typeof useGetReputationLazyQuery>;
export type GetReputationQueryResult = Apollo.QueryResult<GetReputationQuery, GetReputationQueryVariables>;